import React from 'react';
import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/shared/Navbar';
import Home from './pages/Home';
import Post from './pages/Post';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path='/' element={<Home />} />
        <Route path='/posts/:blogId' element={<Post />} />
      </Routes>
    </div>
  );
}

export default App;
